export default __webpack_public_path__ + "static/media/Twitter.80dfe0d9.svg";